import type { ControlAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";
import { hasCoin } from "../utils/zone-utils";

export function validateControl(
  state: WarchestState,
  action: ControlAction,
): ValidationResult {
  if (state.phase !== "USE_COINS") {
    return { valid: false, error: "Not in USE_COINS phase" };
  }
  if (action.player !== state.activePlayer) {
    return { valid: false, error: "Not your turn" };
  }
  const zones = state.playerZones[action.player];
  if (!hasCoin(zones, action.coinType, "hand")) {
    return { valid: false, error: "Coin not in hand" };
  }
  if (action.coinType === "ROYAL") {
    return { valid: false, error: "Royal Coin cannot control a location" };
  }
  const cell = state.board[action.targetHex];
  if (!cell) {
    return { valid: false, error: "No unit at target hex" };
  }
  if (cell.owner !== action.player) {
    return { valid: false, error: "Unit at target hex is not yours" };
  }
  if (cell.unitType !== action.coinType) {
    return {
      valid: false,
      error: "Coin type does not match unit at target hex",
    };
  }
  const location = state.locations[action.targetHex];
  if (!location) {
    return { valid: false, error: "Target hex is not a location" };
  }
  if (location.controlledBy === action.player) {
    return { valid: false, error: "Location is already controlled by you" };
  }
  return { valid: true };
}
